import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CoreDrawerLogo',
  props: {
    hasDefaultLogo: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '',
      required: true
    },
    logo: {
      type: String,
      default: ''
    },
    orientation: {
      type: String,
      default: 'landscape'
    },
    byLine: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['UiTheme', 'miniVariant', 'themes', 'sidebarIconLink'])), {}, {
    specLetter: function specLetter() {
      if (this.byLine) {
        return this.byLine.substring(0, 1);
      }

      return 'N20';
    }
  })
};